<template>
  <div
    class="enter-password text-center"
    :class="{ 'safety-assistant': safetyAssistant }"
  >
    <CardHeader :title="$t('password.enterPassword')" :message="message" />
    <v-text-field
      ref="passwordText"
      v-model="password"
      :append-icon="showPasswordText ? 'mdi-eye' : 'mdi-eye-off'"
      :disabled="loading"
      :rules="[(v) => !!v || $t('password.passwordRequired')]"
      :type="showPasswordText ? 'text' : 'password'"
      class="mb-5 password-field"
      dense
      hide-details
      :label="$t('password.enterPassword')"
      outlined
      sls-element-id="login-input-password-v2"
      @click:append="showPasswordText = !showPasswordText"
      @keydown.enter="submit"
    >
    </v-text-field>

    <router-link
      class="forgot-password-link mb-5"
      to="/reset"
      sls-element-id="login-link-forgot-password"
    >
      {{ $t('password.forgotPassword') }}
    </router-link>

    <PrimaryButton
      class="mb-5"
      :click="submit"
      :disabled="loading"
      sls-element-id="login-button-continue-v2"
    >
      {{ $t('common.next') }}
    </PrimaryButton>

    <SecondaryButton
      :disabled="loading"
      class="mt-4 mb-2"
      @click="setStage('accountFound')"
    >
      {{ $t('login.signInDifferentWay') }}
    </SecondaryButton>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import CardHeader from '@/components/common/CardHeader.vue'
import PrimaryButton from '@/components/common/PrimaryButton.vue'
import SecondaryButton from '@/components/common/SecondaryButton.vue'
import eventTracker from '@/mixins/eventTracker'

export default {
  components: {
    CardHeader,
    PrimaryButton,
    SecondaryButton,
  },
  mixins: [eventTracker],
  data() {
    return {
      disable: false,
      password: null,
      showPasswordText: false,
    }
  },
  computed: {
    ...mapState({
      emailIdentifier: 'emailIdentifier',
      loading: 'loading',
      message: 'message',
      phoneIdentifier: 'phoneIdentifier',
      showPassword: 'showPassword',
      user: 'user',
    }),
    ...mapGetters({
      safetyAssistant: 'safetyAssistant',
    }),
  },
  watch: {
    showPassword(value) {
      if (value === true) {
        this.$refs.passwordText.$el.focus()
      }
    },
  },
  methods: {
    ...mapActions({
      login: 'login',
      setMessage: 'setMessage',
      setStage: 'setStage',
    }),
    async submit() {
      this.setMessage(null)
      if (!this.password) {
        this.setMessage(this.$t('password.passwordRequired'))
        return
      }

      await this.track('password_entered')

      await this.login({
        email: this.emailIdentifier,
        password: this.password,
        phone: this.phoneIdentifier,
      })
    },
  },
}
</script>

<style lang="sass">
.forgot-password-link
  color: $darkBlue
  display: block
  font-size: 0.875rem
  font-weight: 500
  text-decoration: none
  &:hover
    text-decoration: underline

.theme--dark
  .forgot-password-link
    color: $darkBlue !important
  .enter-password .password-field.v-text-field
    ::v-deep
      .v-input__control .v-input__slot
        background-color: $darkBackground !important
        fieldset
          border-color: $darkBorder !important
        &:hover
          fieldset
            border-color: $darkBorderHover !important
        &:focus-within
          fieldset
            border-color: $darkBlue !important
      input
        color: $white !important
        caret-color: $white !important
      .v-label
        color: $textMuted !important
      .v-icon
        color: $textMuted !important
    .v-input__append-inner
      .v-icon
        color: $textMuted !important
.safety-assistant
  .v-text-field
    ::v-deep
      .v-input__slot
        background-color: $darkInputBg !important
        border-color: $darkBorder !important
        &:hover
          border-color: $darkBorderHover !important
        &:focus-within
          border-color: $primaryBlue !important
      input
        color: $white !important
        caret-color: $white !important
      .v-label
        color: $textMuted !important
      .v-icon
        color: $textMuted !important
    .v-input__append-inner
      .v-icon
        color: $textMuted !important
</style>
